import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { Close, Pencil } from '../../../../../assets/icons';
import UseContext from '../../../../../hooks/useContext';
import usefetchdata from '../../../../../hooks/usefetchdata';
import ApiDatabase from '../../../../../server';
import AddressGeoApi from '../../../../AddressGeoApi/AddressGeoApi';
import Button from '../../../../button';
import CopyToClipboardLarge from '../../../../copyToClipboard/copyToClipboardLarge';
import useModal from '../../../../modal/useModal';
import StyledInput from '../../../../styledInput/StyledInput';
import TextSelectMultipleBigAccount from '../../../../textSelectMultiple/textSelectMultipleBigAccount';

const SlideOverCompanyOverview = ({ companyInfo, setCompanyInfo }) => {
  const { userData } = usefetchdata();
  const {
    objID,
    setModalData,
    modalDataReturn,
    setModalDataReturn,
    refreshCompanyBigAccount,
  } = UseContext();
  const { toggle } = useModal();
  const [isCostEstimateDisplay, setIsCostEstimateDisplay] = useState(false);
  const [bigAccount, setBigAccount] = useState('');
  const [modifyCompanyOverview, setModifyCompanyOverview] = useState(false);
  const [companyInfoModified, setCompanyInfoModified] = useState({});
  const [collectiveAgreementDatas, setCollectiveAgreementDatas] = useState([]);
  const [isChangesModifyCompanyOverview, setIsChangesModifyCompanyOverview] =
    useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [companyInfoErrors, setCompanyInfoErrors] = useState({
    errorSiret: '',
    errorCodeApe: '',
    errorStaff: '',
  });
  const statusList = [
    {
      value: null,
      label: 'Choisir',
    },
    {
      value: 'SAS',
      label: 'SAS',
    },
    {
      value: 'SASU',
      label: 'SASU',
    },
    {
      value: 'SARL',
      label: 'SARL',
    },
    {
      value: 'EURL',
      label: 'EURL',
    },
    {
      value: 'SEARL',
      label: 'SEARL',
    },
    {
      value: 'EI',
      label: 'EI',
    },
    {
      value: 'SAI',
      label: 'SAI',
    },
    {
      value: 'GIE',
      label: 'GIE',
    },
    {
      value: 'SCI',
      label: 'SCI',
    },
    {
      value: 'SCOP',
      label: 'SCOP',
    },
    {
      value: 'SICA',
      label: 'SICA',
    },
    {
      value: 'SMIA',
      label: 'SMIA',
    },
    {
      value: 'SNC',
      label: 'SNC',
    },
    {
      value: 'Association',
      label: 'Association',
    },
    {
      value: 'Administration',
      label: 'Administration',
    },
    {
      value: 'Société étrangère',
      label: 'Société étrangère',
    },
    {
      value: 'AUTRES',
      label: 'AUTRES',
    },
  ];
  const token = localStorage.getItem('xsrfToken');
  const [role, setRole] = useState(500);

  useEffect(() => {
    if (userData?.role) {
      setRole(userData.role);
    }
  }, [userData]);

  useEffect(() => {
    ApiDatabase.getDisplayCostEstimate(
      { token: token, idCompany: objID },
      (data) => {
        setIsCostEstimateDisplay(data?.displayCostEstimate);
      },
      (err) => {
        if (err.name !== 'CanceledError') {
          console.error(err);
        }
      }
    );
  }, []);

  const manageDisplayCostEstimate = () => {
    ApiDatabase.putDisplayCostEstimate(
      {
        token: token,
        idCompany: objID,
        displayCostEstimate: !isCostEstimateDisplay,
      },
      (data) => {
        setIsCostEstimateDisplay(!isCostEstimateDisplay);
        toast.success(
          'Les estimations de coût sont maintenant visible par le client'
        );
      },
      (err) => {
        if (err.name !== 'CanceledError') {
          console.error(err);
        }
      }
    );
  };

  const editDescriptionCompany = () => {
    setModalData({ idCompany: companyInfo?._id });
    toggle('edit_description_company');
  };

  useEffect(() => {
    if (modalDataReturn?.description) {
      setCompanyInfo((prevData) => ({
        ...prevData,
        description: modalDataReturn.description,
      }));

      setModalDataReturn({});
    }
  }, [modalDataReturn]);

  useEffect(() => {
    ApiDatabase.getCompanyBigAccount(
      { token: token, idCompany: objID },
      (data) => {
        setBigAccount(data?.bigAccount ?? '');
      },
      (err) => {
        if (err.name !== 'CanceledError') {
          console.error(err);
        }
      }
    );
  }, [refreshCompanyBigAccount]);

  const deleteCompanyBigAccount = () => {
    ApiDatabase.deleteCompanyBigAccount(
      { token: token, idCompany: objID },
      (data) => {
        toast.success('Le grand compte a bien été supprimé');
        setBigAccount('');
      },
      (error) => {
        toast.error(
          `Une erreur est survenue lors de la suppression du grand compte ${error.response.data.message}.`
        );
      }
    );
  };

  useEffect(() => {
    if (companyInfo) {
      setCompanyInfoModified({
        reason_social: companyInfo.reason_social,
        name_commercial: companyInfo.name_commercial,
        address: companyInfo.address,
        siret: companyInfo.siret,
        status: companyInfo.status,
        code_ape: companyInfo.code_ape,
        staff: companyInfo.staff,
        conv_collective: companyInfo.conv_collective,
      });
    }
  }, [companyInfo]);

  useEffect(() => {
    if (token && companyInfo) {
      ApiDatabase.getCollectiveAgreement(
        { token },
        (data) => {
          const updatedData = data.map((item) => ({
            id: item._id,
            name: `${item.IDCC_id} - ${item.IDCC_name}`,
            checked:
              parseInt(companyInfo?.conv_collective) === parseInt(item.IDCC_id),
          }));
          setCollectiveAgreementDatas(updatedData);
        },
        (err) => {
          console.log('err', err);
        }
      );
    }
  }, [token]);

  const updateCollectiveAgreement = (updatedCollectiveAgreement) => {
    const updatedCollectiveAgreements = [...collectiveAgreementDatas];

    for (let i = 0; i < updatedCollectiveAgreements.length; i++) {
      for (let j = 0; j < updatedCollectiveAgreement.length; j++) {
        if (
          updatedCollectiveAgreements[i].id ===
          updatedCollectiveAgreement[j].value
        ) {
          updatedCollectiveAgreements[i].checked =
            updatedCollectiveAgreement[j].checked;
        }
      }
    }

    setCollectiveAgreementDatas(updatedCollectiveAgreements);

    const selectedAgreement = updatedCollectiveAgreements.find(
      (agreement) => agreement.checked
    );

    setCompanyInfoModified((prevState) => ({
      ...prevState,
      conv_collective: selectedAgreement ? selectedAgreement.id : null,
    }));
  };

  useEffect(() => {
    if (companyInfoModified) {
      const errors = {};

      if (
        companyInfoModified.siret &&
        !/^\d{14}$/.test(companyInfoModified.siret)
      ) {
        errors.errorSiret = 'Le siret doit être composé de 14 chiffres.';
      } else {
        errors.errorSiret = '';
      }

      if (
        companyInfoModified.code_ape &&
        !/^\d{4}[A-Za-z]$/.test(companyInfoModified.code_ape)
      ) {
        errors.errorCodeApe =
          "Le code APE doit être composé de 4 chiffres suivis d'une lettre.";
      } else {
        errors.errorCodeApe = '';
      }

      if (
        companyInfoModified.staff &&
        !/^\d+$/.test(companyInfoModified.staff)
      ) {
        errors.errorStaff =
          'Le staff doit être composé uniquement de chiffres.';
      } else {
        errors.errorStaff = '';
      }

      setCompanyInfoErrors(errors);
    }
  }, [companyInfoModified]);

  const fieldsToCompare = [
    { path: 'reason_social', normalizeAsString: true },
    { path: 'name_commercial', normalizeAsString: true },
    { path: 'address.city', normalizeAsString: true },
    { path: 'address.postcode', normalizeAsString: true },
    { path: 'address.street', normalizeAsString: true },
    { path: 'siret', normalizeAsString: true },
    { path: 'status', normalizeAsString: true },
    { path: 'code_ape', normalizeAsString: true },
    { path: 'staff', normalizeAsString: false },
    { path: 'conv_collective', normalizeAsString: true },
  ];

  const getValue = (obj, path) => {
    return path
      .split('.')
      .reduce((acc, key) => (acc ? acc[key] : undefined), obj);
  };

  const normalizeValue = (value, asString) => {
    if (value === undefined || value === null) return '';
    return asString ? value.toString() : value;
  };

  const setValue = (obj, path, value) => {
    const keys = path.split('.');
    let current = obj;
    for (let i = 0; i < keys.length - 1; i++) {
      const key = keys[i];
      if (!(key in current)) {
        current[key] = {};
      }
      current = current[key];
    }
    current[keys[keys.length - 1]] = value;
  };

  useEffect(() => {
    const hasChanges = fieldsToCompare.some(({ path, normalizeAsString }) => {
      const modifiedValue = normalizeValue(
        getValue(companyInfoModified, path),
        normalizeAsString
      );
      const originalValue = normalizeValue(
        getValue(companyInfo, path),
        normalizeAsString
      );
      return modifiedValue !== originalValue;
    });

    const errorsAreEmpty =
      !companyInfoErrors.errorSiret &&
      !companyInfoErrors.errorCodeApe &&
      !companyInfoErrors.errorStaff;

    setIsChangesModifyCompanyOverview(hasChanges && errorsAreEmpty);
  }, [companyInfoModified, companyInfo, companyInfoErrors]);

  const submitModifyCompanyOverview = () => {
    if (
      !companyInfoErrors.errorSiret &&
      !companyInfoErrors.errorCodeApe &&
      !companyInfoErrors.errorStaff &&
      companyInfoModified
    ) {
      let modifiedFields = {};
      let addressModified = false;

      fieldsToCompare.forEach(({ path, normalizeAsString }) => {
        const modifiedValue = normalizeValue(
          getValue(companyInfoModified, path),
          normalizeAsString
        );
        const originalValue = normalizeValue(
          getValue(companyInfo, path),
          normalizeAsString
        );

        if (modifiedValue !== originalValue) {
          if (path.startsWith('address.')) {
            addressModified = true;
          } else {
            setValue(modifiedFields, path, getValue(companyInfoModified, path));
          }
        }
      });

      if (addressModified) {
        modifiedFields.address = companyInfoModified.address;
      }

      setIsLoading(true);
      ApiDatabase.postUpdateCompanyOverview(
        { token, idCompany: companyInfo?._id, companyInfo: modifiedFields },
        (data) => {
          setCompanyInfo((prevCompanyInfo) => {
            let updatedCompanyInfo = {
              ...prevCompanyInfo,
              ...modifiedFields,
            };

            if (modifiedFields.address) {
              updatedCompanyInfo.address = modifiedFields.address;
            }
            if (modifiedFields.conv_collective) {
              const agreement = collectiveAgreementDatas.find(
                (collectiveAgreement) =>
                  collectiveAgreement.id.toString() ===
                  modifiedFields.conv_collective
              );

              if (agreement) {
                updatedCompanyInfo.conv_collective = agreement.name;
              }
            }

            return updatedCompanyInfo;
          });

          setCompanyInfoModified((prevCompanyInfoModified) => ({
            ...prevCompanyInfoModified,
            ...modifiedFields,
          }));

          setModifyCompanyOverview(false);
          setIsLoading(false);

          toast.success(
            "Les informations de l'entreprise ont été mises à jour avec succès."
          );
        },
        (err) => {
          console.log('Erreur:', err);
          toast.error(
            'Une erreur est survenue lors de la mise à jour des informations.'
          );
          setIsLoading(false);
        }
      );
    }
  };

  return (
    <>
      {/* Info grid */}
      <div className={'border border-gray-200 rounded-lg overflow-hidden'}>
        <div className={'grid grid-cols-2 divide-x divide-y divide-gray-200'}>
          <div className={'p-4'}>
            <div className={'flex flex-col'}>
              <div className={''}>Raison sociale</div>
              <div className={'my-auto truncate text-gray-500 text-sm'}>
                {companyInfo?.reason_social || 'Non renseigné'}
              </div>
            </div>
          </div>
          <div className={'p-4'}>
            <div className={'flex flex-col'}>
              <div className={''}>Nom commercial</div>
              <div className={'my-auto truncate text-gray-500 text-sm'}>
                {companyInfo?.name_commercial || 'Non renseigné'}
              </div>
            </div>
          </div>
          <div className={'p-4'}>
            <CopyToClipboardLarge
              libelle={'SIRET'}
              text={companyInfo?.siret || 'Non renseigné'}
            />
          </div>
          <div className={'p-4'}>
            <div className={'flex flex-col'}>
              <div className={''}>Forme juridique</div>
              <div className={'my-auto truncate text-gray-500 text-sm'}>
                {companyInfo?.status || 'Non renseigné'}
              </div>
            </div>
          </div>
          <div className={'p-4'}>
            <div className={'flex flex-col'}>
              <div className={''}>Code APE</div>
              <div className={'my-auto truncate text-gray-500 text-sm'}>
                {companyInfo?.code_ape || 'Non renseigné'}
              </div>
            </div>
          </div>
          <div className={'p-4'}>
            <div className={'flex flex-col'}>
              <div className={''}>Effectif</div>
              <div className={'my-auto truncate text-gray-500 text-sm'}>
                {companyInfo?.staff || 'Non renseigné'}
              </div>
            </div>
          </div>
          <div className={'p-4'}>
            <div className={'flex flex-col'}>
              <div className={''}>Localisation</div>
              {companyInfo?.address ? (
                <>
                  <div className={'text-gray-900 text-sm'}>
                    {companyInfo.address.city}
                    {companyInfo.address.department &&
                      `, ${companyInfo.address.department}`}
                  </div>
                  {companyInfo.address.street && (
                    <div className={'text-gray-500 text-sm'}>
                      {companyInfo.address.street} {companyInfo.address.postcode}
                    </div>
                  )}
                </>
              ) : (
                <div className={'text-gray-500 text-sm'}>Non renseigné</div>
              )}
            </div>
          </div>
          <div className={'p-4'}>
            <div className={'flex flex-col'}>
              <div className={''}>Convention collective</div>
              <div className={'my-auto truncate text-gray-500 text-sm'}>
                {collectiveAgreementDatas?.find(
                  (agreement) => agreement.checked
                )?.name ||
                  companyInfo?.conv_collective ||
                  'Non renseigné'}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Brief de l'entreprise */}
      <div className={'border border-gray-200 rounded-lg p-3'}>
        <div className={'flex justify-between items-start gap-2'}>
          <div className={'flex flex-col flex-1'}>
            <div className={''}>Brief de l'entreprise</div>
            <div className={'text-gray-500 text-sm mt-1'}>
              {companyInfo?.description || 'Aucun brief renseigné'}
            </div>
          </div>
          <div
            className={
              'border border-gray-300 rounded-md w-8 h-8 flex justify-center items-center cursor-pointer hover:bg-gray-50 transition-colors flex-shrink-0'
            }
            onClick={() => editDescriptionCompany()}
          >
            <Pencil wh={18} color={'#374151'} />
          </div>
        </div>
      </div>

      {/* Estimation de coût */}
      <div className={'border border-gray-200 rounded-lg p-3'}>
        <div className={'flex justify-between items-center'}>
          <div className={''}>Estimations de coût</div>
          <input
            type="checkbox"
            checked={isCostEstimateDisplay}
            onChange={() => manageDisplayCostEstimate()}
          />
        </div>
      </div>

      {/* Grand compte */}
      <div className={'border border-gray-200 rounded-lg p-3'}>
        <div className={'flex flex-col gap-3'}>
          <div className={''}>Associé au groupe</div>
          {bigAccount ? (
            <div
              className={
                'flex justify-between items-center gap-2 p-3 border border-gray-200 rounded-lg bg-gray-50'
              }
            >
              <div className={'flex flex-col'}>
                <div className={'text-gray-900 text-sm font-medium'}>
                  {bigAccount?.name}
                </div>
                <div className={'text-gray-500 text-xs'}>
                  le{' '}
                  {bigAccount?.companies.find(
                    (item) => item.id_company === objID
                  )?.date &&
                    new Date(
                      bigAccount?.companies.find(
                        (item) => item.id_company === objID
                      )?.date
                    ).toLocaleDateString('fr-FR', {
                      year: 'numeric',
                      month: 'long',
                      day: 'numeric',
                      hour: '2-digit',
                      minute: '2-digit',
                    })}
                </div>
              </div>
              <div
                className={
                  'border border-gray-300 rounded-md w-8 h-8 flex justify-center items-center cursor-pointer hover:bg-gray-50 transition-colors flex-shrink-0'
                }
                onClick={() => deleteCompanyBigAccount()}
              >
                <Close wh={18} color={'#374151'} />
              </div>
            </div>
          ) : (
            <TextSelectMultipleBigAccount />
          )}
        </div>
      </div>

      {/* Modifier les informations */}
      {(role === 500 || role === 515) && (
        <div
          className={
            'border border-gray-200 rounded-lg p-3 flex flex-col gap-4'
          }
        >
          <div className={'flex gap-2 justify-between items-center'}>
            <div className={''}>Modifier les informations</div>
            {!modifyCompanyOverview ? (
              <div
                className={
                  'border border-gray-300 rounded-md w-8 h-8 flex justify-center items-center cursor-pointer hover:bg-gray-50 transition-colors flex-shrink-0'
                }
                onClick={() => setModifyCompanyOverview(true)}
              >
                <Pencil wh={18} color={'#374151'} />
              </div>
            ) : (
              <div
                className={
                  'border border-gray-300 rounded-md w-8 h-8 flex justify-center items-center flex-shrink-0 opacity-50'
                }
              >
                <Pencil wh={18} color={'#6B7280'} />
              </div>
            )}
          </div>
          {modifyCompanyOverview && (
            <>
              <div className={'flex flex-col gap-4 text-sm'}>
                <div className={'flex gap-1 items-center'}>
                  <div className={'w-1/2 font-medium'}>Raison sociale</div>
                  <div className={'w-1/2 text-gray-700'}>
                    <StyledInput
                      type={'text'}
                      value={companyInfoModified?.reason_social}
                      onChange={(e) => {
                        setCompanyInfoModified((prevData) => ({
                          ...prevData,
                          reason_social: e.target.value,
                        }));
                      }}
                    />
                  </div>
                </div>
                <div className={'flex gap-1 items-center'}>
                  <div className={'w-1/2 font-medium'}>Nom commercial</div>
                  <div className={'w-1/2 text-gray-700'}>
                    <StyledInput
                      type={'text'}
                      value={companyInfoModified?.name_commercial}
                      onChange={(e) => {
                        setCompanyInfoModified((prevData) => ({
                          ...prevData,
                          name_commercial: e.target.value,
                        }));
                      }}
                    />
                  </div>
                </div>
                <div className={'flex gap-1 items-center'}>
                  <div className={'w-1/2 font-medium'}>Adresse</div>
                  <div className={'w-1/2 text-gray-700'}>
                    <AddressGeoApi
                      addressGeoValue={(address) => {
                        setCompanyInfoModified((prevData) => ({
                          ...prevData,
                          address: address,
                        }));
                      }}
                      addressValue={companyInfoModified.address}
                      page={'editCompany'}
                    />
                  </div>
                </div>
                <div className={'flex gap-1 items-center'}>
                  <div className={'w-1/2 font-medium'}>SIRET</div>
                  <div className={'w-1/2 text-gray-700'}>
                    <StyledInput
                      type={'number'}
                      value={companyInfoModified?.siret}
                      onChange={(e) => {
                        setCompanyInfoModified((prevData) => ({
                          ...prevData,
                          siret: e.target.value,
                        }));
                      }}
                      error={companyInfoErrors?.errorSiret}
                    />
                  </div>
                </div>
                <div className={'flex gap-1 items-center'}>
                  <div className={'w-1/2 font-medium'}>Forme juridique</div>
                  <div className={'w-1/2 text-gray-700'}>
                    <StyledInput
                      type={'select'}
                      value={companyInfoModified.status}
                      list={statusList}
                      onChange={(e) => {
                        setCompanyInfoModified((prevDatas) => ({
                          ...prevDatas,
                          status: e.target.value,
                        }));
                      }}
                    />
                  </div>
                </div>
                <div className={'flex gap-1 items-center'}>
                  <div className={'w-1/2 font-medium'}>Code APE</div>
                  <div className={'w-1/2 text-gray-700'}>
                    <StyledInput
                      type={'text'}
                      value={companyInfoModified?.code_ape}
                      onChange={(e) => {
                        setCompanyInfoModified((prevData) => ({
                          ...prevData,
                          code_ape: e.target.value,
                        }));
                      }}
                      error={companyInfoErrors?.errorCodeApe}
                    />
                  </div>
                </div>
                <div className={'flex gap-1 items-center'}>
                  <div className={'w-1/2 font-medium'}>Effectif</div>
                  <div className={'w-1/2 text-gray-700'}>
                    <StyledInput
                      type={'number'}
                      value={companyInfoModified?.staff}
                      onChange={(e) => {
                        setCompanyInfoModified((prevData) => ({
                          ...prevData,
                          staff: e.target.value,
                        }));
                      }}
                      error={companyInfoErrors?.errorStaff}
                    />
                  </div>
                </div>
                <div className={'flex gap-1 items-center'}>
                  <div className={'w-1/2 font-medium'}>
                    Convention collective
                  </div>
                  <div className={'w-1/2 text-gray-700'}>
                    <StyledInput
                      type={'selectMultipleRadio'}
                      value={
                        collectiveAgreementDatas.filter(
                          (qualification) => qualification.checked === true
                        ).length > 0
                          ? collectiveAgreementDatas
                              .filter(
                                (qualification) =>
                                  qualification.checked === true
                              )
                              .map((qualification) => qualification.name)
                              .join(', ')
                          : '-'
                      }
                      list={collectiveAgreementDatas.map(
                        (collectiveAgreement) => {
                          return {
                            value: collectiveAgreement.id,
                            label: collectiveAgreement.name,
                            checked: collectiveAgreement.checked,
                          };
                        }
                      )}
                      onChange={(updatedCollectiveAgreement) =>
                        updateCollectiveAgreement(updatedCollectiveAgreement)
                      }
                      isSearchable
                    />
                  </div>
                </div>
              </div>
              <div className={'flex items-center justify-end gap-2'}>
                <Button
                  size={'SM'}
                  color={'SECONDARY'}
                  onClick={() => setModifyCompanyOverview(false)}
                >
                  Annuler
                </Button>
                {isChangesModifyCompanyOverview ? (
                  <>
                    {isLoading ? (
                      <Button size={'SM'} color={'DISABLED'}>
                        Confirmation ...
                      </Button>
                    ) : (
                      <Button
                        size={'SM'}
                        color={'PRIMARY'}
                        onClick={() => submitModifyCompanyOverview()}
                      >
                        Confirmer
                      </Button>
                    )}
                  </>
                ) : (
                  <Button size={'SM'} color={'DISABLED'}>
                    Confirmer
                  </Button>
                )}
              </div>
            </>
          )}
        </div>
      )}
    </>
  );
};

export default SlideOverCompanyOverview;
